"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const types_1 = require("@framework/types");
const column_1 = require("../column");
const styled_1 = require("./styled");
const statuses = [types_1.OrderStatus.NEW, types_1.OrderStatus.SCHEDULED, types_1.OrderStatus.NOW_IN_DELIVERY, types_1.OrderStatus.DELIVERED];
const Board = (props) => {
    const { initial, onOrderStatusChange, onEdit } = props;
    const [columns, setColumns] = (0, react_1.useState)(initial);
    const [ordered, setOrdered] = (0, react_1.useState)(Object.values(types_1.OrderStatus));
    (0, react_1.useEffect)(() => {
        setColumns(initial);
        setOrdered(statuses);
    }, [initial]);
    const onDragEnd = ({ source, destination, draggableId }) => {
        // dropped nowhere
        if (!destination) {
            return;
        }
        console.info(`Order #${draggableId} moved from '${source.droppableId}' to '${destination.droppableId}'`);
        onOrderStatusChange(draggableId, destination.droppableId);
    };
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd, children: (0, jsx_runtime_1.jsx)(styled_1.StyledContainer, { children: ordered.map((status, index) => ((0, jsx_runtime_1.jsx)(column_1.Column, { index: index, status: status, items: columns[status], onEdit: onEdit }, status))) }) }));
};
exports.Board = Board;
//# sourceMappingURL=index.js.map